import React from 'react'
import Experience from './Experience.jsx'

import EXPERIENCE_EL_TODO_IMAGE_PATH from 'images/experience_el_todo.jpg'
import EXPERIENCE_EL_TODO_SONG_PATH from 'audio/2. MUTANDO MB.mp3'

const ElTodoText = () => (
	<span className="text-left">
		<p>La coexistencia de de tus líneas temporales es la crónica anunciada de una parálisis.</p>

		<p>Y si les damos su lugar:</p>
		<p>El pasado como constitución. El futuro como el cúmulo de deseos ensoñados. Y el presente:</p>
		<p>¿Qué te dice?</p>
		<p>De él se desprende tu futuro.</p>
		<p>Y el pasado, de él construís tu presente. Agradecelo. Enojate. Duela.</p>
		<p>Acepta lo que no hubo para comprender lo que sí.</p>
		<p>Mi pasado y mi futuro conectados inexorablemente por la falta y la resultante en deseo.</p>
		<p>Y ahora sí, ¿qué está sucediendo en tu presente?</p>
	</span>
)

const ElTodoPhrase = () => {
	return (<>
	¿Estás encarnando el presente, la mezcla desordenada de heridas pasadas o los deseos futuros que aún no se han nombrado?
	</>)
}

const ExperienceElTodo = (props) => {
	return (<Experience
		image={EXPERIENCE_EL_TODO_IMAGE_PATH}
		title={"El todo"}
		phrase={<ElTodoPhrase />}
		phrase_rect={{ top: 50, left: 76.6, width: 40.5, height: 20 }}
		text={<ElTodoText />}
		text_rect={{ top: 50, left: 22.5, width: 40, height: 90 }}
		text_interaction_zone_rect={{ top: 44, left: 1.5, width: 7, height: 13 }}
		song={EXPERIENCE_EL_TODO_SONG_PATH}
		song_rect={{ top: 19, left: 84.5, width: 13, height: 15 }}
		{...props}
	/>)			
}

export default ExperienceElTodo